var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLowerCase = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.604 8.351a2.2 2.2 0 0 0-.686-.773 3.3 3.3 0 0 0-1.04-.481 4.9 4.9 0 0 0-1.306-.167q-.991 0-1.697.307-.705.305-1.108.837a2.6 2.6 0 0 0-.499 1.207l2.173.076a.9.9 0 0 1 .361-.558q.285-.202.75-.202.435 0 .69.202t.255.573v.024a.4.4 0 0 1-.176.35q-.176.121-.561.187-.386.065-1.016.123a6 6 0 0 0-1.06.186q-.496.136-.876.401a1.86 1.86 0 0 0-.597.689q-.217.425-.217 1.04 0 .732.315 1.217.315.483.863.722.545.239 1.254.239.515 0 .927-.13.41-.13.718-.391.305-.26.503-.635h.058v1.03h.684a4.702 4.702 0 0 1 1.53-3.797v-1.23q.001-.588-.242-1.046M8.51 11.794q0 .362-.183.634a1.26 1.26 0 0 1-.488.426 1.5 1.5 0 0 1-.686.154q-.405 0-.668-.192-.263-.193-.263-.56 0-.24.123-.416a.9.9 0 0 1 .357-.287q.233-.11.566-.163l.342-.053a5 5 0 0 0 .657-.149q.143-.044.243-.096z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CBB17",
    d: "M14.021 10.85a3.26 3.26 0 1 0 0 6.521 3.26 3.26 0 0 0 0-6.52m1.554 4.912a.39.39 0 0 1-.388.389h-2.332a.39.39 0 0 1-.388-.389v-1.943a.39.39 0 0 1 .388-.388h.195v-.389a.971.971 0 1 1 1.942 0v.39h.195c.213 0 .388.174.388.387zM14.02 12.44a.603.603 0 0 0-.603.602v.39h1.205v-.39a.603.603 0 0 0-.602-.602m0 1.962a.39.39 0 0 0-.389.389.389.389 0 1 0 .389-.389",
    className: "lock"
  })));
};
export default SvgLowerCase;